import { useState, useCallback } from 'react';
import { SnackbarSeverityType } from '../../../enums';
import academicYears from '../../../apis/academicYears';
import { YearEntry } from '../types/AcademicYearTypes';
import { parseAcademicYearResponse } from './utils';

export const useAcademicYears = (
  schoolId: string | undefined,
  showToast: (msg: string, severity: SnackbarSeverityType) => void
) => {
  const [entries, setEntries] = useState<YearEntry[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!schoolId) return;
    setIsLoading(true);
    try {
      const response = await academicYears.getAcademicYears(schoolId);
      const rawAcademicYears = Array.isArray(response)
        ? response
        : response?.data || [];
      const yearEntries: YearEntry[] = rawAcademicYears.flatMap((data: any) =>
        parseAcademicYearResponse(data)
      );
      setEntries(yearEntries);
    } catch (err) {
      console.error(err);
      showToast('Failed to load academic years.', SnackbarSeverityType.error);
      setEntries([]);
    } finally {
      setIsLoading(false);
    }
  }, [schoolId, showToast]);

  return { entries, isLoading, refresh };
};
